import { Box, Typography, Chip } from "@mui/material";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination, EffectFade } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/effect-fade";
import { useMemo } from "react";

const SLIDES = [
  {
    image: "/images/banner1.jpg",
    quote: "Engage, create, and be yourself.",
    sub: "Share your world with the people that matter.",
    tag: "Connect",
  },
  {
    image: "/images/banner2.jpg",
    quote: "Every story deserves to be told.",
    sub: "What will you share with the world today?",
    tag: "Share",
  },
  {
    image: "/images/banner3.jpg",
    quote: "Your world. Your style. Your voice.",
    sub: "Build connections that go beyond the screen.",
    tag: "Inspire",
  },
];

const Banner = () => {
  const slides = useMemo(() => SLIDES, []);

  return (
    <Box
      sx={{
        position: "relative",
        width: "100%",
        height: { xs: 240, sm: 320, md: 380 },
        mb: 3,
        borderRadius: "16px",
        overflow: "hidden",
        boxShadow: "0 8px 32px rgba(26,26,46,0.22)",
      }}
    >
      <Swiper
        modules={[Autoplay, Pagination, EffectFade]}
        effect="fade"
        autoplay={{ delay: 4000, disableOnInteraction: false }}
        pagination={{ clickable: true }}
        loop
        style={{ width: "100%", height: "100%" }}
      >
        {slides.map((slide, index) => (
          <SwiperSlide key={index}>
            <Box
              sx={{
                position: "relative",
                width: "100%",
                height: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              {/* Background image */}
              <img
                src={slide.image}
                alt={`Slide ${index + 1}`}
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                  position: "absolute",
                  inset: 0,
                }}
              />

              {/* Gradient overlay */}
              <Box
                sx={{
                  position: "absolute",
                  inset: 0,
                  background:
                    "linear-gradient(to top, rgba(26,26,46,0.85) 0%, rgba(26,26,46,0.4) 50%, rgba(26,26,46,0.15) 100%)",
                }}
              />

              {/* Text content */}
              <Box
                sx={{
                  position: "relative",
                  zIndex: 2,
                  textAlign: "center",
                  px: { xs: 2, sm: 4 },
                  maxWidth: 600,
                }}
              >
                <Chip
                  label={slide.tag}
                  size="small"
                  sx={{
                    mb: 1.5,
                    bgcolor: "rgba(212,175,55,0.2)",
                    color: "#D4AF37",
                    border: "1px solid rgba(212,175,55,0.5)",
                    fontWeight: 700,
                    fontSize: 11,
                    letterSpacing: 1,
                    textTransform: "uppercase",
                  }}
                />
                <Typography
                  sx={{
                    color: "#fff",
                    fontSize: { xs: 20, sm: 26, md: 32 },
                    fontWeight: 800,
                    lineHeight: 1.2,
                    letterSpacing: "-0.5px",
                    textShadow: "0 2px 12px rgba(0,0,0,0.4)",
                    mb: 1,
                  }}
                >
                  {slide.quote}
                </Typography>
                <Typography
                  sx={{
                    color: "rgba(255,255,255,0.7)",
                    fontSize: { xs: 13, sm: 15 },
                    fontWeight: 400,
                    textShadow: "0 1px 4px rgba(0,0,0,0.4)",
                  }}
                >
                  {slide.sub}
                </Typography>
              </Box>
            </Box>
          </SwiperSlide>
        ))}
      </Swiper>
    </Box>
  );
};

export default Banner;
